import { breakpoints as r } from "./atoms-v2125.js";
import a from "styled-components";
import { Text as p } from "./atoms-v243.js";
const l = a.div`
  display: flex;
  flex-direction: column;
  padding: 24px;

  @media ${r.small} {
    padding: 12px 16px 16px;
  }
`, s = a.div`
  background-color: ${({ $colorTheme: o, theme: i }) => i == null ? void 0 : i.get(`tokens.surface.${o}.layer01`)};
  border-radius: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.radius.cardSmall")}px;
  display: flex;
  flex-direction: column;
  padding: 12px 16px;

  @media ${r.small} {
    padding: 10px 12px;
  }
`, t = a.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`, x = a.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`, g = a.div`
  display: flex;
  justify-content: space-between;
`, $ = a(p)`
  color: ${({ $colorTheme: o, theme: i }) => i == null ? void 0 : i.get(`tokens.text.${o}.primary`)};
  ${({ theme: o }) => {
  var i;
  return (i = o == null ? void 0 : o.get("tokens.body.productive")) == null ? void 0 : i.toJS();
}};

  @media ${r.small} {
    ${({ theme: o }) => {
  var i;
  return (i = o == null ? void 0 : o.get("tokens.helper.productive")) == null ? void 0 : i.toJS();
}};
  }
`, u = a(p)`
  color: ${({ $colorTheme: o, theme: i }) => i == null ? void 0 : i.get(`tokens.text.${o}.primary`)};
  ${({ theme: o }) => {
  var i;
  return (i = o == null ? void 0 : o.get("tokens.heading.compact-02")) == null ? void 0 : i.toJS();
}};

  @media ${r.small} {
    ${({ theme: o }) => {
  var i;
  return (i = o == null ? void 0 : o.get("tokens.heading.compact-01")) == null ? void 0 : i.toJS();
}};
  }
`, y = a(p)`
  color: ${({ $colorTheme: o, theme: i }) => i == null ? void 0 : i.get(`tokens.text.${o}.primary`)};
  ${({ theme: o }) => {
  var i;
  return (i = o == null ? void 0 : o.get("tokens.body.productive")) == null ? void 0 : i.toJS();
}};

  @media ${r.small} {
    ${({ theme: o }) => {
  var i;
  return (i = o == null ? void 0 : o.get("tokens.helper.productive")) == null ? void 0 : i.toJS();
}};
  }
`;
export {
  s as AccordionSection,
  t as AccordionStack,
  y as PoliciesText,
  $ as RateDescription,
  g as SummaryItem,
  x as SummaryWrapper,
  u as TotalLabel,
  l as Wrapper
};
